import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl34 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{font-family:Helvetica-Bold,\n            Helvetica;font-size:19.63px;font-weight:700;}.cls-1,.cls-2{fill:currentColor;}\n        " }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_34",
		children: [/* @__PURE__ */ _jsx("path", {
			className: "cls-2",
			d: "M54,17.28c1.65,0,3,1.35,3,3v22c0,1.65-1.35,3-3,3H10c-1.65,0-3-1.35-3-3v-22c0-1.65,1.35-3,3-3h44M54,15.28H10c-2.76,0-5,2.24-5,5v22c0,2.76,2.24,5,5,5h44c2.76,0,5-2.24,5-5v-22c0-2.76-2.24-5-5-5h0Z"
		}), /* @__PURE__ */ _jsx("text", {
			className: "cls-1",
			transform: "translate(11.28 38.28)",
			children: /* @__PURE__ */ _jsx("tspan", {
				x: 0,
				y: 0,
				children: "VMZ"
			})
		})]
	})]
});
export default SvgAppIcBefehl34;
